import { render } from "./AddSubjectPage.vue?vue&type=template&id=00fe1a68&scoped=true"
import script from "./AddSubjectPage.vue?vue&type=script&lang=js"
export * from "./AddSubjectPage.vue?vue&type=script&lang=js"

import "./AddSubjectPage.vue?vue&type=style&index=0&id=00fe1a68&lang=stylus&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00fe1a68"]])

export default __exports__